// Категории коллекций — недвижимость (связаны с домами/застройкой и т.п.).
// Бэкенд хранит category как произвольную строку (slug), поэтому значения = slug.
export var COLLECTION_CATEGORIES = [
    { value: "residential", label: "Residential" },
    { value: "commercial", label: "Commercial" },
    { value: "development", label: "Development" },
    { value: "land", label: "Land" },
    { value: "mixed-use", label: "Mixed-use" },
    { value: "industrial", label: "Industrial" },
    { value: "hospitality", label: "Hospitality" },
];
// Регионы карты (6 зон). Если заданы координаты — регион/страна проставляются
// автоматически на бэке (reverse-geocoding).
export var COLLECTION_REGIONS = [
    { value: "north-america", label: "North America" },
    { value: "south-america", label: "South America" },
    { value: "africa", label: "Africa" },
    { value: "europe", label: "Europe" },
    { value: "asia", label: "Asia" },
    { value: "oceania", label: "Oceania" },
];
export var COLLECTION_TYPES = [
    "AUCTION",
    "PAST_AUCTION",
    "VANISH",
];
export var COLLECTION_TYPE_LABELS = {
    AUCTION: "Auction",
    PAST_AUCTION: "Past Auction",
    VANISH: "Vanish",
};
export var WIZARD_PAYMENT_METHODS = [
    "QUANTA",
    "USDC",
    "USDT",
    "BNB",
    "CAKE",
    "TWT",
];
